import { render, staticRenderFns } from "./EpsNotificationPage.vue?vue&type=template&id=069f32d2&"
import script from "./EpsNotificationPage.vue?vue&type=script&lang=js&"
export * from "./EpsNotificationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports